import {useEventContext} from "@platform/context/EventContext";
import {useParams} from "react-router-dom";
import {useEffect} from "react";
import { useWidgetContext } from "../../context/WidgetContextProvider";

const colorVariables = {
    'accent-color': '--app-accent-color-rgb',
    'dark-color': '--app-color-dark-rgb',
    'light-color': '--app-color-light-rgb',
    'border-radius': '--app-border-radius',
};

const borderRadiusVariable = '--app-border-radius';

const hexToRGB = (hex) => {
    if (hex.length === 3) {
        hex = '' + hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    return [
        parseInt(hex.substring(0, 2), 16),
        parseInt(hex.substring(2, 4), 16),
        parseInt(hex.substring(4, 6), 16),
    ];
};

const updateTheme = (vars) => {
    const rootStyle = document.querySelector(':root').style;

    Object.keys(vars).forEach((name) => {
        rootStyle.setProperty(colorVariables[name], hexToRGB(vars[name]).join(','));
    });

    const darkColor = hexToRGB(vars['dark-color']).reduce((acc, prev) => acc + prev);
    const lightColor = hexToRGB(vars['light-color']).reduce((acc, prev) => acc + prev);

    lightColor < darkColor ? document.body.classList.add('theme-light') : document.body.classList.remove('theme-light');
    document.body.dataset.loaded = 'true';
};

const updateSettings = (vars) => {
    const rootStyle = document.querySelector(':root').style;

    rootStyle.setProperty(borderRadiusVariable, vars['border-radius']);
};

export default ({page}) => {
    const { event } = useEventContext();
    const { widgetSettings } = useWidgetContext();
    const params = useParams();
    const theme = event.moduleTheme;

    useEffect(() => {
        const rootStyle = document.querySelector(':root').style;

        if (theme.fontFamily) {
            const link = document.createElement('link');
            link.href = theme.fontFamily.path;
            link.rel = 'stylesheet';
            document.head.appendChild(link);

            rootStyle.setProperty('--app-font', theme.fontFamily.name);
        } else {
            rootStyle.removeProperty('--app-font');
        }

        const {accentColor, backgroundColor, textColor} = theme;

        updateTheme({
            'accent-color': accentColor,
            'dark-color': backgroundColor,
            'light-color': textColor,
        });

    }, [theme]);

    useEffect(() => {
        updateSettings({
            'border-radius': widgetSettings?.borderRadiusSize || event.moduleTheme.borderRadiusSize || '4px',
        });

        updateTheme({
            'accent-color': widgetSettings?.accentColor || event.moduleTheme.accentColor,
            'dark-color': widgetSettings?.backgroundColor || event.moduleTheme.backgroundColor,
            'light-color': widgetSettings?.textColor || event.moduleTheme.textColor,
        });

        window.addEventListener('message', (event) => {
            try {
                const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
                updateTheme(data);
            } catch (e) { }
        });

        const body = document.querySelector('body');
        if (widgetSettings?.transparentBackground) {
            body.style.backgroundColor = 'unset';
        } else if (body.style.backgroundColor === 'unset') {
            body.style.backgroundColor = '';
        }
    }, [widgetSettings]);

    useEffect(() => {
        const className = page || params['*'];
        const rootBlock = document.querySelector('#root');

        rootBlock.setAttribute('class', `${className}-page-root`);
        rootBlock.style.backgroundImage = '';
    }, [params, page]);

    return null;
};
